<template lang="html">
  <v-dialog v-model="isVisible" max-width="440" persistent>
    <v-card>
      <v-system-bar dark window color="accent">
        <v-icon center>{{ getMessageIcon( type ) }}</v-icon>
        <v-toolbar-title class="ml-1">Сообщение</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small icon @click.native="onCancel()">
          <v-icon class="mx-0">clear</v-icon>
        </v-btn>
      </v-system-bar>
      <v-card-text>{{ message }}</v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" flat @click.native="onConfirm()">{{ confirmText }}</v-btn>
      </v-card-actions>
    </v-card>
    
 
  </v-dialog>
</template>

<script>
  import monitor from '../../../mixins/monitor'

  export default {
    mixins: [monitor],

    props: {
      visible: {
        type: Boolean,
        default: false
      },
      message: {
        type: String,
        default: ''
      },
      type: {
        type: String,
        default: 'info'
      },
      confirmText: {
        type: String,
        default: 'Ok'
      },
    },

    data() {
      return {
        isVisible: this.visible
      }
    },

    watch: {
      visible: function (newVal) {
        this.isVisible = newVal
      }
    },

    methods: {
      onCancel: function () {
        this.$emit('cancel')
      },
      onConfirm: function () {
        this.$emit('confirm')
      }
    }
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/apps/bpm/superMonitor/components/utils/InfoMessageModal.vue